const COOKIE_CONSENT_KEY = "cookie-consent";

export type CookieConsent = "accepted" | "declined";

export const getCookieConsent = (): CookieConsent | null => {
  const value = localStorage.getItem(COOKIE_CONSENT_KEY);

  if (!value) {
    return null;
  }

  return value as CookieConsent;
};

export const setCookieConsent = (consent: CookieConsent) => {
  localStorage.setItem(COOKIE_CONSENT_KEY, consent);
};
